//import apiServices from "../../../../services/apiServices";
//import jwtDecode from "jwt-decode";

export default {
  state: {
    saldo: {
      showSaldo: true,
      showCarregar: false
    }
  },
  mutations: {
    SET_SHOW_SALDO(state, value) {
      state.saldo.showSaldo = value;
    },
    SET_SHOW_CARREGAR(state, value) {
      state.saldo.showCarregar = value;
    }
  },
  actions: {
    setShowSaldo(context, value) {
      context.commit("SET_SHOW_SALDO", value);
    },

    setShowCarregar(context, value) {
      context.commit("SET_SHOW_CARREGAR", value);
    }
  },

  getters: {
    getShowSaldo(state) {
      return state.saldo.showSaldo;
    },
    getShowCarregar(state) {
      return state.saldo.showCarregar;
    }
  }
};
